/**
 * Fait suivre le curseur à un badge (ex. "Découvrir" au survol des blocs 3D).
 *
 * Le badge est en `position: fixed` et ne capte jamais le pointeur (cf. `.cursor-badge`) : c'est la
 * zone survolée qui porte le lien. On le décale en bas à gauche du pointeur pour ne pas masquer
 * l'élément survolé.
 */
export default function followCursorBadge(zone, badge) {
	if (!zone || !badge) return;

	zone.addEventListener("mouseenter", () => badge.classList.add("is-visible"));
	zone.addEventListener("mouseleave", () => badge.classList.remove("is-visible"));
	zone.addEventListener("mousemove", (e) => {
		badge.style.transform = `translate3d(${e.clientX - badge.offsetWidth - 8}px, ${e.clientY + 18}px, 0)`;
	});
}
